import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';
import { BadgeComponent, ButtonComponent, IconComponent } from '@recruitee/user-interface';

import { FeatureTooltipModule } from '../../ui/feature-tooltip/feature-tooltip.module';
import { FeatureTooltipWrapperComponent } from './feature-tooltip-wrapper.component';
import { FeatureTooltipWrapperDirective } from './feature-tooltip-wrapper.directive';

@NgModule({
  imports: [
    BadgeComponent,
    ButtonComponent,
    CommonModule,
    FeatureTooltipModule,
    I18nModule,
    IconComponent,
    FeatureTooltipWrapperComponent,
    FeatureTooltipWrapperDirective,
  ],
  exports: [FeatureTooltipWrapperComponent, FeatureTooltipWrapperDirective],
})
export class FeatureTooltipWrapperModule {}

export { FeatureTooltipWrapperDirective, FeatureTooltipWrapperComponent };
